<template>
  <div v-if="collection" class="p-4 mb-8">

    <div v-if="collection.content">
      <div @click="togglePanel(0)" class="cursor-pointer">
        <div class="flex w-full items-start justify-between text-left">
          <h1 class="font-bold text-2xl tracking-tight text-zinc-950 lg:text-3xl">
            {{ collection.title }}
          </h1>
          <span class="ml-6 flex h-7 items-center">
            <span class="nba rotate-90 text-2xl">></span>
          </span>
        </div>
      </div>
      <div v-show="activePanel === 0" class="text-block">
        <div class="text-base md:text-lg font-semibold pt-4 text-block" v-html="collection.content"></div>
      </div>
      <hr role="presentation" class="mb-6 mt-4 lg:mb-10 lg:mt-6 w-full border-t border-zinc-950/10">
    </div>
    <div v-else>
      <h1 class="font-bold text-2xl mb-4 tracking-tight text-zinc-950 lg:text-3xl">
        {{ collection.title }}
      </h1>
      <hr role="presentation" class="mb-6 mt-4 lg:mb-10 lg:mt-6 w-full border-t border-zinc-950/10">
    </div>

    <div
    v-if="collection"
    class="mx-auto mt-4 md:mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-3 xl:grid-cols-4"
    >
      <CardRudiment v-for="(rudiment, index) in collection.collections_rudiments" :play="false" :rudiment="rudiment" type="collection" />
    </div>
  </div>
</template>

<script setup>
const { $seo } = useNuxtApp()
const route = useRoute()
const slug = route.params.slug
const optionsStore = useOptionsStore()

const supabase = useSupabaseClient()
const config = useRuntimeConfig()

const activePanel = ref(999)
const togglePanel = index => {
  const activeIndex = activePanel.value
  if (index === activeIndex) {
    activePanel.value = 999
  } else {
    activePanel.value = index
  }
}

const { data: collection } = await useAsyncData(
  'collection-'+slug, 
  async () => {
    const { data } = await supabase
    .from('collections')
    .select(`
      *,
      image(
        id,
        filename_download,
        width,
        height
      ),
      collections_rudiments(
        rudiments_sort,
        rudiments(
          title, 
          slug,
          image(
            id,
            filename_download,
            width,
            height
          ),
          rudiments_rudiment_categories(
            rudiment_categories(
              title,
              slug
            )
          )  
        )
      ),
      seo(
        *,
        meta_image(
          id,
          filename_download,
          width,
          height
        )
      )
    `)
    .eq('slug', slug)
    .in('status', config.public.postStatus.split(','))
    .order('rudiments_sort', { referencedTable: 'collections_rudiments', ascending: true })
    .maybeSingle()
    return data
  }
)

optionsStore.setBreadcrumbs([
  { title: 'Collections', to: '/play/collections' },
  { title: `${collection.value?.title}`, to: `/play/collection/${slug}` }
])

const seo = computed(() => {
  if (collection.value?.seo) {
    return $seo(collection.value.seo, route.fullPath)
  }
  return $seo({
    meta_title: `How To Play the ${collection.value.title}`, 
    meta_description: `Sign up to Drum Rudiments and play ${collection.value.title}! Free 7-day trial.`, 
    meta_image: collection.value?.image
  }, route.fullPath)
})

useHead(seo)

</script>